import { CashBalanceBucketDTO } from '@/client/cust/Type/CashBalanceBucketDTO'
import { CorpBalanceVO } from '@/client/cust/Type/CorpBalanceVO'
import { CorpRealNameAuthInfoVO } from '@/client/cust/Type/CorpRealNameAuthInfoVO'
import { CustInfoVO } from '@/client/cust/Type/CustInfoVO'
import { custInfoByCid } from '@/client/cust/apis/custInfoByCid'
import { queryBalanceBucket } from '@/client/cust/apis/queryBalanceBucket'
import { queryBalanceInfo } from '@/client/cust/apis/queryBalanceInfo'
import { realNameauthInfo } from '@/client/cust/apis/realNameauthInfo'
import { EntInfoVO } from '@/client/ent/Type/EntInfoVO'
import { info } from '@/client/ent/apis/info'
import { useState } from 'react'

export default function Index() {
	/* 客户信息 */
	const [corpInfo, setCorpInfo] = useState<CustInfoVO>()
	const updateCorpInfo = ({ cid }: { cid: string }) => {
		return custInfoByCid({ cid: cid }).then((res) => {
			setCorpInfo(res)
		})
	}
	const [entInfo, setEntInfo] = useState<EntInfoVO>()
	const getEntInfo = ({ cid }: { cid: string }) => {
		return info({ cid: cid }).then((res) => {
			setEntInfo(res)
		})
	}
	/* 认证信息 */
	const [authInfo, setAuthInfo] = useState<CorpRealNameAuthInfoVO>()
	const getRealNameauthInfo = ({ cid }: { cid: string }) => {
		return realNameauthInfo({ cid: cid }).then((res) => {
			setAuthInfo(res)
		})
	}
	// 客户余额信息
	const [balance, setBalance] = useState<CorpBalanceVO>()
	const [balanceBucket, setBalanceBucket] = useState<CashBalanceBucketDTO>()
	const updateBalanceInfo = ({
		cid,
		canQueryBalanceBucket = false,
	}: {
		cid: string
		canQueryBalanceBucket?: boolean
	}) => {
		const balanceRequest = queryBalanceInfo({ cid }).then((res) => {
			setBalance(res)
		})
		const balanceBucketRequest = canQueryBalanceBucket
			? queryBalanceBucket({ cid }).then((res) => {
					setBalanceBucket(res)
			  })
			: Promise.resolve(setBalanceBucket(undefined))

		return Promise.all([balanceRequest, balanceBucketRequest])
	}

	return {
		corpInfo,
		updateCorpInfo,
		entInfo,
		getEntInfo,
		authInfo,
		getRealNameauthInfo,
		balance,
		balanceBucket,
		updateBalanceInfo,
	}
}
